import { AuthLayout } from '@/modules/auth/ui/components'
import { LoadingSpinner } from '@/shared/ui/components'
import { Button } from '@/shared/ui/primitives'
import type {
  ExchangeTransferCode,
  LoadSession,
  SetSession,
} from '@/modules/auth/use-cases'
import type { LoadMemberContext } from '@/shared/domain'
import { useTransferPage } from './hooks/use-transfer-page'

export type TransferPageProps = {
  onExchangeTransferCode: ExchangeTransferCode
  onSetSession: SetSession
  onLoadSession: LoadSession
  onLoadMemberContext: LoadMemberContext
}

export function TransferPage(props: TransferPageProps) {
  const vm = useTransferPage(props)

  if (vm.status === 'access-denied') {
    return (
      <AuthLayout
        title="Access denied"
        subtitle="Your account doesn't have permission to use the Command Center."
      >
        <div data-testid="transfer-access-denied" className="flex flex-col gap-4">
          <p className="text-sm text-muted-foreground">
            You need an active club or outfitter membership to use the Command Center.
          </p>
          <Button onClick={vm.onGoToLogin} variant="default" className="w-full">
            Go to login
          </Button>
        </div>
      </AuthLayout>
    )
  }

  if (vm.status === 'failed') {
    return (
      <AuthLayout title="Login Failed" subtitle="We couldn't complete your sign-in.">
        <div data-testid="transfer-failed" className="flex flex-col gap-4">
          <Button onClick={vm.onGoToLogin} variant="default" className="w-full">
            Go to login
          </Button>
        </div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout title="Signing you in" subtitle="Hang tight while we complete the transfer.">
      <div
        data-testid="transfer-loading"
        className="flex flex-col items-center justify-center gap-3 py-6"
      >
        <LoadingSpinner size="lg" />
        <p className="text-sm text-muted-foreground">{vm.message}</p>
      </div>
    </AuthLayout>
  )
}
